import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'

import { actions as appActions } from '../../store/modules/app'
import { WithContentfulPage } from '../../components/WithContentfulPage'
import ContactUs from '../../containers/ContactUs'


const ContactUsPage = ({ pathname }) => {
  const dispatch = useDispatch()
  const router = useRouter()

  const onSubmit = useCallback((fields = {}) => {
    const { name, email, message } = fields
    return dispatch(appActions.submitContactUsForm({
      name,
      email,
      message
    }))
      .then(() => {
        router.push({
          pathname: `/${pathname}/thanks`
        })
      })
  })

  return (
      <ContactUs onSubmit={onSubmit} />
  )
}


export default WithContentfulPage(ContactUsPage)
